import React from 'react';
import clsx from 'clsx';
import { format, formatDistanceToNowStrict, fromUnixTime } from 'date-fns';
import { useTimer } from '@hooks/useTimer';

export const FormatStrictCoundown = ({
  timeStamp,
  onExpire,
  hideUnit = false,
  expandedFormat = false,
}: {
  timeStamp: number;
  onExpire?: () => void;
  hideUnit?: boolean;
  expandedFormat: boolean;
}) => {
  const startTimeStamp = React.useMemo(() => fromUnixTime(timeStamp).getTime(), [timeStamp]);
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp: startTimeStamp,
    onExpire,
  });

  const moreThanADay = days > 0;

  return moreThanADay ? (
    <>
      {expandedFormat
        ? format(startTimeStamp, 'MMM dd, h:mma')
        : formatDistanceToNowStrict(startTimeStamp, { roundingMethod: 'floor' })}
    </>
  ) : (
    <span
      className={clsx(
        'inline-flex items-start',
        [hours > 0 && (hideUnit ? 'min-w-[60px]' : 'min-w-[98px]')],
        [hours <= 0 && minutes > 0 && (hideUnit ? 'min-w-[44px]' : 'min-w-[66px]')],
        [days > 0 && 'w-fit'],
      )}
    >
      {/* TODO: https://linear.app/sound/issue/ENG-7451/time-text-make-helper */}
      {hours > 0 && `${String(hours).padStart(2, '0')}${hideUnit ? ':' : 'h'}`}
      {!hideUnit && ' '}
      {minutes >= 0 && `${String(minutes).padStart(2, '0')}${hideUnit ? ':' : 'm'}`}
      {!hideUnit && ' '}
      {days === 0 &&
        minutes >= 0 &&
        seconds >= 0 &&
        `${String(seconds).padStart(2, '0')}${hideUnit ? '' : 's'}`}
    </span>
  );
};
